<template>
<div class="page-container">
  <el-scrollbar height="100%"  @scroll="scroll" ref="scrollContainer">
    <el-timeline class="time-line-container" ref="innerContainer">
      <el-timeline-item
        v-for="(log) in strategyLogList" :key="log.created_time"
        :timestamp="log.created_time" placement="top"
      >
        <!-- 时间线的symbol-icon -->
        <template #dot>
          <div class="timeline-dot-symbol"></div>
        </template>
        <!-- 策略历史列表 -->
        <div class="card-container">
          <div class="item-container">
            <span class="title">{{ $str.getKey('策略控制/操作人：') }}</span>
            <span class="content">{{ log.opt_user }}</span>
          </div>
          <div class="item-container">
            <span class="title">{{ $str.getKey('策略控制/操作类型：') }}</span>
            <span class="content">{{ getOptType(log) }}</span>
          </div>
          <div class="item-container">
            <span class="title">{{ $str.getKey('策略控制/操作内容：') }}</span>
            <span class="content">
              <span>{{ getContent(log)}}</span>

              <span v-if="log.log_type === 'strategy_info'" class="open-detail" @click="log.isShowDetail = !log.isShowDetail">
                {{log.isShowDetail ? $str.getKey('策略控制/收起') : $str.getKey('策略控制/展开')}}<div :class="['arrow', log.isShowDetail ? 'arrow-open' : 'arrow-close']"></div>
              </span>
              <span v-else-if="log.log_type == 'custom_strategy_modify' || log.log_type == 'custom_strategy_add' || log.log_type == 'custom_strategy_delete'" class="open-detail" @click="log.isShowCustomDetail = !log.isShowCustomDetail">
                {{log.isShowCustomDetail ? $str.getKey('策略控制/收起') : $str.getKey('策略控制/展开')}}<div :class="['arrow', log.isShowCustomDetail ? 'arrow-open' : 'arrow-close']"></div>
              </span>
              
            </span>
          </div>
          <div v-if="log.isShowDetail" class="details-panel">
            <div class="title-text">{{ $str.getKey('策略控制/策略详情') }}</div>
            <!-- 单选框 -->
            <div class="select-type-container">
              <el-radio-group v-model="log.formModel.viewType">
                <el-radio label="table">{{ $str.getKey('策略控制/表单') }}</el-radio>
                <el-radio label="diff">{{ $str.getKey('策略控制/差异') }}</el-radio>
              </el-radio-group>
            </div>
            <!-- 表格部分的panel -->
            <div class="details-container">
              <!-- 表格 -->
              <template v-if="log.formModel.viewType == 'table'">
                <div class="table-container">
                  <p>{{ $str.getKey('策略控制/修改前策略数据') }}</p>
                  <div>
                    <Table :columns="oldColumns" :data="log.formModel.strategy_old" />
                  </div>
                </div>
                <div class="table-container">
                  <p>{{ $str.getKey('策略控制/修改后策略数据') }}</p>
                  <div>
                    <Table :columns="newColumns" :data="log.formModel.strategy_new" />
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="strategy-difference">
                  <table>
                    <thead class="strategy-diff-thead">
                      <tr class="strategy-diff-tr">
                        <th>
                          {{ $str.getKey('策略控制/操作') }}
                        </th>
                        <th>
                          {{ $str.getKey('策略控制/开始时间') }}
                        </th>
                        <th>{{ $str.getKey('策略控制/结束时间') }}</th>
                        <th>{{ $str.getKey('策略控制/功率') }}</th>
                        <th>
                          {{ $str.getKey('策略控制/充电上限') }}
                        </th>
                        <th>
                          {{ $str.getKey('策略控制/放电下限') }}
                        </th>
                        <th v-if="props.hasPvAccess">
                          {{ $str.getKey('策略控制/模式') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(diffItem, index) in diffValue(log.formModel.strategy_old, log.formModel.strategy_new)"
                      :key="index" :class="{ 'is-add': diffItem.__is_add, 'is-del': diffItem.__is_del}">
                        <td>{{ getOperate(diffItem) }}</td>
                        <td>{{ diffItem.startTime }}</td>
                        <td>{{ diffItem.endTime }}</td>
                        <td>{{ diffItem.power }}</td>
                        <td>{{ diffItem.upperLimit }}</td>
                        <td>{{ diffItem.lowerLimit }}</td>
                        <td v-if="props.hasPvAccess">{{ formatModeCell({ running_mode: diffItem.running_mode, threshold_val: diffItem.threshold_val }) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </div>

          </div>
          <div v-if="log.isShowCustomDetail" class="custom-details-panel">
            <ResuseCustomStrategy :data="log.old_custom_strategy || []" :name="$str.getKey('策略控制/修改前')"></ResuseCustomStrategy>
            <ResuseCustomStrategy :data="log" :differentialData="getCustomDetailDifference(log)" :name="$str.getKey('策略控制/修改后')"></ResuseCustomStrategy>
          </div>
        </div>
        
      </el-timeline-item>
      <div :style="{'margin-top': '40px'}" v-loading="addCtrl.loading" :element-loading-text="$str.getKey('策略控制/加载中...')"></div>
    </el-timeline>
  </el-scrollbar>

</div>

<!-- ====== 复用局部组件：展示自定义策略变化前后的内容 =============================================== -->
<DefineCustomStrategy v-slot="{ name, data, differentialData }">
  <div class="custom-strategy-detail">
    <div class="title-container title-text">{{ name }}</div>
    <div class="content-container">
      <div class="info-items">
        <div class="info-item">
          {{ $str.getKey('策略控制/策略名称') }}: <span class="item-value" :class="getCustomStrategyTextClassName(differentialData, 'custom_strategy_name')" v-text="data.custom_strategy_name || '--'"></span>
        </div>
        <div class="info-item">
          {{ $str.getKey('策略控制/生效日期') }}: <span class="item-value" :class="getCustomStrategyTextClassName(differentialData, 'execution_time')" v-text="data.execution_time || '--'"></span>
        </div>
        <div class="info-item">
          {{ $str.getKey('策略控制/需量') }}: <span class="item-value" :class="getCustomStrategyTextClassName(differentialData, 'demand')" v-text="data.demand || '--'"></span>
        </div>
        <div class="info-item">
          {{ $str.getKey('策略控制/充放电模式') }}: <span class="item-value" :class="getCustomStrategyTextClassName(differentialData, 'week_plan')" v-text="translateWeekPan(data.week_plan)"></span>
        </div>
        <div class="info-item">
          {{ $str.getKey('策略控制/允许虚拟电厂调度') }}: <span class="item-value" :class="getCustomStrategyTextClassName(differentialData, 'third_ctl_en')" v-text="translateThird_ctl_en(data.third_ctl_en)"></span>
        </div>
      </div>
      <div class="strategy-table">
        <span class="title-text">{{ $str.getKey('策略控制/工作日策略') }}:</span>
        <ResuseStrategyList :strategyList="data.strategys_work"
          :class="getCustomStrategyTextClassName(differentialData, 'strategys_work')"></ResuseStrategyList>
      </div>
      <div class="strategy-table">
        <span class="title-text">{{ $str.getKey('策略控制/休息日策略') }}:</span>
        <ResuseStrategyList :strategyList="data.strategys_rest"
          :class="getCustomStrategyTextClassName(differentialData, 'strategys_rest')"></ResuseStrategyList>
      </div>

    </div>
  </div>
</DefineCustomStrategy>
<DefineStrategyList v-slot="{ strategyList }">
  <div class="info-table-container table">
    <el-table :data="strategyList" :border="true">
      <el-table-column :label="$str.getKey('策略控制/开始时间')" prop="start_time"></el-table-column>
      <el-table-column :label="$str.getKey('策略控制/结束时间')" prop="end_time"></el-table-column>
      <el-table-column :label="$str.getKey('策略控制/功率')" prop="power"></el-table-column>
      <el-table-column :label="$str.getKey('策略控制/充电上限')" prop="upper_limit"></el-table-column>
      <el-table-column :label="$str.getKey('策略控制/放电下限')" prop="lower_limit"></el-table-column>
      <el-table-column v-if="props.hasPvAccess" :label="$str.getKey('策略控制/模式')" min-width="160">
        <template #default="{ row }">{{ formatModeCell(row) }}</template>
      </el-table-column>
    </el-table>
  </div>
</DefineStrategyList>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from 'vue'
import dayjs from "dayjs";
import { createReusableTemplate } from '@vueuse/core'
import * as elinkApi from '../api.js';
import {
  compareStrategy,
  getMinutesCountByTime,
  STRATEGY_MODE_OPTIONS,
  getThresholdPlaceholder,
} from "../utils.js"
import useAppStore from '@/store/modules/app'
import Table from '../components/Table.vue'

const [DefineCustomStrategy, ResuseCustomStrategy] = createReusableTemplate();
const [DefineStrategyList, ResuseStrategyList] = createReusableTemplate()
const $str = window.$str;

// const props = defineProps(['elinkId'])
const props = defineProps({
  elinkId: {
    type: String,
    default: ''
  },
  hasPvAccess: {
    type: Boolean,
    default: false
  }
});

const scrollContainer = ref(null);
const innerContainer = ref(null);
const addCtrl = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  hadGetAll: false,
  loading: false
})

const appStore = useAppStore();
const stationId = computed(() => appStore.stationId );
let strategyLogList = ref([]); // 策略历史列表
// const typesMap = new Map([
//   ["demand", "需量变更"],
//   ["week_plan", "计划变更"],
//   ["strategy_type", "策略类型变更"],
//   ["strategy_info", "策略内容变更"],
//   ["third_ctl_en", "虚拟电厂调度更改"]
// ]);
const typesMap = new Map([
  [['demand'], '需量变更'],
  [['week_plan'], '计划变更'],
  [['strategy_type'], '策略类型变更'],
  [['strategy_info'], '策略内容变更'],
  [['third_ctl_en'], '虚拟电厂调度更改'],
  [['demand_min_weekday'], '工作日防逆流更改'],
  [['demand_min_weekend'], '休息日防逆流更改'],
  [['custom_strategy_modify', 'custom_strategy_delete', 'custom_strategy_add'], '自定义策略'],
]);
const oldColumns = computed(() => [
  { prop: "start_time", label: "开始时间" },
  { prop: "end_time", label: "结束时间"},
  { prop: "power", label: "功率"},
  { prop: "upper_limit", label: "充电限制"},
  { prop: "lower_limit", label: "放电下限"},
  { prop: "running_mode", label: "模式", hidden: !props.hasPvAccess, minWidth: 160, formatter: (row) => formatModeCell(row) },
]);
const newColumns = computed(() => [
  { prop: "start_time", label: "开始时间" },
  { prop: "end_time", label: "结束时间"},
  { prop: "power", label: "功率"},
  { prop: "upper_limit", label: "充电限制"},
  { prop: "lower_limit", label: "放电下限"},
  { prop: "running_mode", label: "模式", hidden: !props.hasPvAccess, minWidth: 160, formatter: (row) => formatModeCell(row) },
]);

function formatModeCell(row = {}) {
  const mode = row.running_mode ?? row.mode
  if (mode === '' || mode == null) {
    return '--'
  }
  const opt = STRATEGY_MODE_OPTIONS.find(it => it.value === Number(mode))
  const modeLabel = opt ? $str.getKey('策略控制/' + opt.label) : mode
  const threshold = row.threshold_val ?? row.threshold
  if (threshold === '' || threshold == null) {
    return modeLabel
  }
  const thresholdLabel = $str.getKey('策略控制/' + getThresholdPlaceholder(Number(mode)))
  return `${modeLabel}（${thresholdLabel}：${threshold}）`
}

onMounted(() => {
  getHistoryList(addCtrl.currentPage, addCtrl.pageSize);
})

/** 监听eLinkId变化，更新数据 */
watch(() => props.elinkId, (nv, ov) => {
  addCtrl.currentPage = 1;
  addCtrl.pageSize = 10;
  strategyLogList.value = [];
  getHistoryList(addCtrl.currentPage, addCtrl.pageSize);
})

/** 获取eLink的策略修改历史List */
async function getHistoryList(pageNum, pageSize) {
  addCtrl.loading = true;
  if (stationId.value && props.elinkId) {
    elinkApi.strategyHistory(stationId.value, props.elinkId, pageNum, pageSize).then(res => {
      const list = res?.data?.strategyLogList || [];
      list.forEach(log => {
        log['isShowDetail'] = false;
        log['isShowCustomDetail'] = false;
        /** 格式化时间格式 */
        log.created_time = dayjs(log.created_time).format('YYYY-MM-DD HH:mm:ss')
        /** 整理详情面板中要展示的数据 */
        const key = log.strategys_work ? 'strategys_work' : (log.strategys_rest ? 'strategys_rest' : '');
        const formModel = {
          viewType: ref('table'), // 默认表格展示修改前后的数据
          // strategy_old: log.old_strategy[key] ?? [],
          strategy_old: log.old_strategy ? (log.old_strategy[key] ?? []): [],
          // log.old_custom_strategy // 自定义策略，修改前
          strategy_new: log[key] ?? [],
        }
        log['formModel'] = formModel;
      });
      // strategyLogList.value = list;
      strategyLogList.value.push(...list);
      addCtrl.total = res?.data?.total || 0;
      addCtrl.hadGetAll = strategyLogList.value.length >= addCtrl.total;
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      addCtrl.loading = false;
    })
  } else {
    console.error('eLinkId或stationId不能为空')
  }
}

/** 获取操作类型 */
function getOptType(record) {
  // return typesMap.get(record.log_type);
  for (const [keys, value] of typesMap) {
    if (keys.includes(record.log_type)) {
      return value
    }
  }
}

/** 获取操作内容 */
function getContent(record) {
  const Type = {
    demand() {
      return (
        "将需量由" + record.old_strategy.demand + "改为" + record.demand
      );
    },
    week_plan() {
      const oldValue = record.old_strategy.week_plan;
      const newValue = record.week_plan;
      return `将充放电计划由 “${translateWeekPan(
        oldValue
      )}” 修改为 “${translateWeekPan(newValue)}”`;
    },
    strategy_type() {
      const oldValue = record.old_strategy.strategy_type;
      const newValue = record.strategy_type;
      const date = record.strategy_date;
      // return `将 ${date} 的 “${translateStrategyType(oldValue)}策略” 修改为 “${translateStrategyType(newValue)}策略”`
      return `将 ${date} 的策略修改为 “${translateStrategyType(newValue)}策略”`;
    },
    strategy_info() {
      if (record.strategys_work != null) {
        return $str.getKey('策略控制/修改了工作日策略');
      } else if (record.strategys_rest != null) {
        return $str.getKey('策略控制/修改了休息日策略');
      }
      return "";
    },
    third_ctl_en() {
      const tb = {
        0: "关闭",
        1: "打开"
      };
      const s = tb[record.third_ctl_en] ?? "";

      if (record != null) {
        return `${s}了虚拟电厂调度选项`;
      } else {
        return "--";
      }
    },
    demand_min_weekday() {
      let tabData = record.demand_min_weekday >- 60000?1:0
      const tb = {
        0: "关闭",
        1: "打开"
      };
      const s = tb[tabData] ?? "";

      if (record != null) {
        return `${s}了工作日防逆流`;
      } else {
        return "--";
      }
    },
    demand_min_weekend() {
       let tabData = record.demand_min_weekend >- 60000?1:0
      const tb = {
        0: "关闭",
        1: "打开"
      };
      const s = tb[tabData] ?? "";

      if (record != null) {
        return `${s}了休息日防逆流`;
      } else {
        return "--";
      }
    },

    custom_strategy_modify() {
      return $str.getKey('策略控制/修改了自定义策略')
    },
    custom_strategy_delete() {
      return $str.getKey('策略控制/删除了自定义策略')
    },
    custom_strategy_add() {
      return $str.getKey('策略控制/增加了自定义策略')
    }
  };

  const fn = Type[record.log_type];
  const text = fn ? fn() : "";
  return text;
}

/** 获取差异数据 */
const diffValue = computed(() => {
  return (strategy_old, strategy_new) =>
    getStrategyDiff(strategy_old, strategy_new);
});


const getOperate = record => {
  if (record.__is_add) {
    return "+";
  }
  if (record.__is_del) {
    return "-";
  }
  return "";
};

/** 滚动到buff范围内，加载下一页数据 */
const scroll = ({ scrollTop }) => {
  const innerHigt = innerContainer.value.$el.clientHeight;
  const containerHigt = scrollContainer.value.$el.clientHeight;
  const buffHeight = 150;
  const isNeedGetData = !addCtrl.hadGetAll && !addCtrl.loading && ((innerHigt - containerHigt - scrollTop) < buffHeight)
  if (isNeedGetData) {
    ++addCtrl.currentPage;
    getHistoryList(addCtrl.currentPage, addCtrl.pageSize);
  }
  
}

/** ======【help-functions】======================================================== */

function translateWeekPan(weekType) {
  const 单双休 = {
    0: "无休",
    1: "单休",
    2: "双休"
  };
  return 单双休[weekType];
}

function translateStrategyType(strategyType) {
  const 作息 = {
    work: "工作日",
    rest: "休息日"
  };
  return 作息[strategyType];
}

const getStrategyDiff = (old_json = [], new_json = []) => {
  // 全部属性转化为大写 方便比较
  old_json = transformJSON(old_json);
  new_json = transformJSON(new_json);

  const diff = [];

  // 比较一条策略是否一致
  const keys = ["startTime", "endTime", "lowerLimit", "upperLimit", "power"]
  if (props.hasPvAccess) {
    keys.push("running_mode", "threshold_val")
  }
  const isSameValue = (a, b) => {
    return keys.every(key => a[key] === b[key]);
  }

  // const insertAt = (list, value, position) => {
  //   list.splice(position, 0, value);
  // };

  // 1.先标注出a中被删除的项(从b中找，找不到的为被删除的)
  // 2.找出b中增加的项（从a中找，找不到的为新增的）并且插入到合适的位置
  // 3.找出b中新增项位置的方法：
  // 取b中上一个元素在a中的位置（index），b中新增项的上一个元素在a中存在时，待插入元素的索引为（index+1），不存在时说明上一个元素也是新增的，
  // 待插入元素的索引为上一个元素的待插入索引+1。此外要考虑找出b中新增项为第一个元素的情况

  const hasValue = (array, value) => {
    const res = array.find(item => isSameValue(item, value));
    return !!res;
  };

  for (let i = 0; i < old_json.length; i++) {
    const a = old_json[i];
    const hasA = hasValue(new_json, a);
    a.__is_del = !hasA;
  }

  diff.push(...old_json);

  for (let j = 0; j < new_json.length; j++) {
    const b = new_json[j];
    const hasB = hasValue(old_json, b);
    b.__is_add = !hasB;
    if (!hasB) {
      // insertAt(diff, b, 0)
      diff.push(b);
    }
  }
  diff.sort((a, b) => {
    const timeA = getMinutesCountByTime(a.startTime);
    const timeB = getMinutesCountByTime(b.startTime);
    if (timeA === timeB) {
      if (a.__is_del) {
        return -1;
      } else {
        return 1;
      }
    } else {
      return timeA > timeB ? 1 : -1;
    }
  });
  return diff;
};

function transformJSON(array) {
  if (!Array.isArray(array)) {
    return [];
  }
  return array.map(item => {
    return {
      startTime: item.start_time,
      endTime: item.end_time,
      lowerLimit: item.lower_limit,
      upperLimit: item.upper_limit,
      power: item.power,
      running_mode: item.running_mode ?? item.mode ?? '',
      threshold_val: item.threshold_val ?? item.threshold ?? 10,
    };
  });
};

function getCustomDetailDifference(log) {
  const newData = log
  const oldData = log.old_custom_strategy || {}
  const Keys = ['custom_strategy_name', 'execution_time', 'demand', 'week_plan', 'third_ctl_en', 'strategys_rest', 'strategys_work']

  const object = {}

  if (newData.log_type === 'custom_strategy_modify') {
    Keys.forEach(key => {
      const value = newData[key]
      const oldValue = oldData[key]
      if (Array.isArray(value)) {
        object[key] = !compareStrategy(value, oldValue)
      } else {
        object[key] = value !== oldValue
      }
    })
  }

  return object
}

/** 如果key对应的数据和之前不一样，动态绑定class设置样式 */
function getCustomStrategyTextClassName(differentialData = {}, key) {
  return {
    'has-change': differentialData[key],
  }
}


function translateThird_ctl_en(value) {
  let map = {
    0: '否',
    1: '是',
  }
  return map[value] || '--'
}


</script>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: 100%;

  .card-container {
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 6px;
    padding: 10px;

    .item-container {
      width: 100%;
      display: flex;
      line-height: 30px;
      font-family: PingFang-SC, PingFang-SC;
      font-size: 14px;
      color: #2E2E2EB2;
      .title{
        min-width: 80px;
        text-align: right;
      }
      .content {
        width: 200px;
        flex: 1 1 auto;
        word-wrap:break-word;
        $normal-blue-color: #3A68FF;
        .open-detail {
          padding: 0 6px;
          display: inline-flex;
          align-items: center;
          color: $normal-blue-color;
          cursor: pointer;
          .arrow {
            width: 8px;
            height: 8px;
            border-width: 1px;
            border-style: solid;
            border-color: $normal-blue-color $normal-blue-color transparent transparent;
            &.arrow-close {
              transform: rotate(45deg);
            }
            &.arrow-open {
              transform: rotate(135deg);
              margin-left: 6px;
            }
          }
        }

      }
    }

    .details-panel {
      width: 100%;
      background: #FFFFFF;
      margin: 6px;
      padding: 10px;
      border-radius: 6px;
      .title-text {
        line-height: 30px;
        font-family: PingFang-SC, PingFang-SC;
        font-size: 14px;
        color: #FFFFFF;
      }
      .select-type-container {
        padding: 6px 0;
      }
      .details-container {
        width: 100%;
        display: flex;
        gap: 6px;
        color: lime;

        .table-container {
          width: 50%;
        }

        .strategy-difference {
          width: 100%;

          table {
            width: 100%;
            border-collapse: collapse;
            border: #ebeef5 1px solid;
            
            .strategy-diff-thead {
              // background: #3A5FB111;
              .strategy-diff-tr {
                height: 40px;
                padding: 10px;
                text-align: left;
                background: var(--strategy-tr);
              }
            }

            th,
            td {
              padding-left: 5px;
              padding-right: 5px;
              border-bottom: 1px solid #ebeef5;
              border-right: 1px solid #ebeef5;
            }

            tr.is-add {
              background-color: var(--strategy-add);
            }

            tr.is-del {
              background-color: var(--strategy-del);
            }
          }
        }

      }
    }

    .custom-details-panel {
      font-family: PingFang-SC, PingFang-SC;
      letter-spacing: 1px;
      background: #ffffff;
      margin: 6px;
      padding: 10px;
      border-radius: 6px;
      display: flex;
      gap: 8px;
      .custom-strategy-detail {
        width: 50%;
        // padding: 10px;
        flex: 1 1 auto;

        .title-text {
          font-size: 14px;
          font-weight: 600;
          line-height: 28px;
        }

        .title-container {
          // margin: 8px 0;
          // font-size: 16px;
        }
        .content-container {
          .info-items {
            padding: 6px 0;
            display: flex;
            flex-wrap: wrap;
            .info-item {
              width: 48%;
              line-height: 24px;
              .item-value {
                font-size: 14px;
                font-weight: 600;
                color: #2E2E2EDD;
              }
            }
          }
          .strategy-table {
            width: 100%;
            padding: 6px 0;
            .info-table-container {
              width: 100%;
            }
          }

          .has-change {
            border-bottom: 2px solid;
          }
        }

      }

    }

  }


  // 修改时间线的样式
  ::v-deep .timeline-dot-symbol {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #3A68FF !important;
    background: #FFFFFF;
  }
  ::v-deep .el-timeline-item__tail {
    color: #3A68FF !important;
    --el-timeline-node-color: #3A68FF !important;
    left: 7px;
    top: 15px;
    bottom: 16px;
    
  }

}


</style>



